import axios from 'axios'
import { buildURL } from '../helper'
import apiConfig from '../../config/apiConfig'
import { getBpIdParam } from '../../common/helper'
import { trackFeatureAction } from '../../common/otel'

const skipFeedbackSurvey = async (
  survey_id: string,
  skip_timer_duration: number,
) => {
  const bpIdParam = getBpIdParam()
  trackFeatureAction('feedback_survey_skip', 'attempt')
  try {
    const { data } = await axios.patch(
      `${buildURL('feedbackSurveyResponse', apiConfig.feedback)}${bpIdParam}`,
      {
        survey_id,
        skip_timer_duration,
      },
    )
    trackFeatureAction('feedback_survey_skip', 'success')
    return data
  } catch (error) {
    trackFeatureAction('feedback_survey_skip', 'error')
    throw error
  }
}

export default skipFeedbackSurvey
